import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-workout-sidebar',
    templateUrl: './workout-sidebar.component.html',
    styleUrls: ['./workout-sidebar.component.scss'],
    standalone: false
})
export class WorkoutSidebarComponent {
  @Input() activeTab: string = 'dashboard';
  @Output() tabChange = new EventEmitter<string>();

  tabs = [
    { key: 'dashboard', icon: '🏠', label: 'Dashboard' },
    { key: 'workouts', icon: '💪', label: 'Workouts' },
    { key: 'exercises', icon: '🏋️‍♂️', label: 'Exercises' },
    { key: 'routines', icon: '📋', label: 'Routines' },
  ];

  onTabClick(tab: string) {
    this.tabChange.emit(tab);
  }
}

